import axiosInstance from "../../../../config/apiConfig";
import { useMutation, useQueryClient } from '@tanstack/react-query'; 

const dismissReportedPost = async ({ blogId, dismissedById, reason = null }) => {
  try {
    const { data } = await axiosInstance.put(
      `reports/${blogId}/status/Dismissed`,
      { dismissedById, reason }
    );
    return data;
  } catch (err) {
    console.error('Error dismissing report:', err.response?.data || err.message);
    throw err;
  }
};

 const useDismissReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dismissReportedPost,
    onSuccess: () => {
      queryClient.invalidateQueries(['reportedPosts']); 
    },
    onError: (err) => {
      console.error('Failed to dismiss report:', err);
    },
  });
};

export default useDismissReport